export default {
    orderItem: null,
    tabStatus: 0,
    expressCompanies: [],
    logisticDetail: null,
    pickStatus: false,
    pickupInit: null,
}


// WEBPACK FOOTER //
// ./src/store/my-order/state.js